import { Controller } from "@hotwired/stimulus"
import { getUserLocale, parseLocaleNumber } from "../../utils/number-format.util"

// Parses locale-formatted numbers back to raw numbers before form submission
// Skips parsing for build_association actions (add item buttons) that rebuild forms
export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.#handleFormSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("submit", this.#handleFormSubmit.bind(this))
  }

  #handleFormSubmit(event) {
    // Skip number parsing for "add item" actions (build_association paths)
    // These actions rebuild the form but don't save data, so formatting is preserved
    if (this.#isBuildAssociationAction(event.submitter)) {
      return
    }

    this.#parseFormattedNumbers()
  }

  #parseFormattedNumbers() {
    const locale = getUserLocale()
    const inputs = this.#getFormattedNumberInputs()

    inputs.forEach((input) => {
      if (input.value) {
        input.value = parseLocaleNumber(input.value, locale)
      }
    })
  }

  #getFormattedNumberInputs() {
    return Array.from(this.element.querySelectorAll('input[type="text"], input[type="number"], textarea')).filter(
      (input) => {
        const action = input.getAttribute("data-action")
        return action?.includes("formatNumber")
      }
    )
  }

  // Check if the submit action is a "build_association" (add item) action
  // These actions rebuild forms but don't save data, so we preserve formatted values
  #isBuildAssociationAction(submitter) {
    if (!submitter) return false

    const formAction = submitter.getAttribute("formaction")
    return formAction?.includes("build_association") ?? false
  }
}
